export const environment = {
  production: true,
  local: false,
  settings: {
    okta: {
      clientId: '',
      scope: '',
      oidc: false,
      issuer: 'https://ecova2.okta.com',
      sessionLength: null,
      sessionTimeoutWindow: null,
      sessionLengthFromToken: false
    },
    appInsights: {
      instrumentationKey: '484e2aeb-b94f-4143-966b-9a02376fb0a5'
    },
    api_url: 'https://dev-e2-api-ms.azure-api.net/eda/',
    core_api_url: 'https://dev-e2-api-ms.azure-api.net/',
    api_subscription_key: '753f0391dc75411b94327e01bbd43eed',
    api_subscription_trace: 'false',
    token_exchange_url: '',
    token_exchange_secret: ''
  }
};
